<template>
  <div id="formBody">
    <div style="align:right" slot="top-right">
      <button style="float: right;" v-on:click="cancelAction()">❌</button>
    </div>
    <div id="formBodyTitle" v-if="isEditable == false">View Notification</div>
    <div id="formBodyTitle" v-else-if="startData">Edit Notification</div>
    <div id="formBodyTitle" v-else>New Notification</div>
    <div class="fromItemContainer">
      <p class="labels">Message Text (Required)</p>
      <input
        class="input"
        v-model="message"
        placeholder="Add the message's text"
        :disabled="isEditable == false"
      />
    </div>
    <div class="fromItemContainer">
      <p class="labels">Message Label</p>
      <input
        class="input"
        v-model="title"
        placeholder="Enter message label"
        :disabled="isEditable == false"
      />
    </div>
    <p class="labels">Launch URL</p>
    <input
      class="input"
      style="margin-bottom:25px"
      v-model="url"
      placeholder="Add url here"
      :disabled="isEditable == false"
    />
    <NotificationFormImage
      v-bind:startData="startData"
      v-bind:isEditable="isEditable"
      @uploadImageResult="uploadImageResult"
      @imageUrlResult="imageUrlResult"
    />
    <div>
      Delivery
      <v-radio-group :disabled="isEditable == false" v-model="delivery" row>
        <v-radio color="red" label="Send immediately" value="0"></v-radio>
        <v-radio label="Schedule notification" value="1"></v-radio>
      </v-radio-group>
      <div class="fromItemContainer" v-if="delivery == 1">
        <div id="mainDateContainer">
          <div class="dateDataContainer">
            <div class="dateDataContainerTitle">Date</div>
            <DatePicker
              id="datePicker"
              v-model="date"
              color="blue"
              :popover="popoverConfig"
              :min-date="new Date()"
              v-if="isEditable == true"
            />
            <input
              id="datePicker"
              v-model="showCalendarDate"
              v-if="isEditable == false"
              :disabled="true"
            />
          </div>
          <div class="dateDataContainer">
            <div class="dateDataContainerTitle">Time</div>
            <div id="hourContainer">
              <input
                class="hourInput"
                v-model="hours"
                placeholder="00"
                @change="validateHours"
                :disabled="isEditable == false"
              /> :
              <input
                class="hourInput"
                v-model="minutes"
                placeholder="00"
                @change="validateMin"
                :disabled="isEditable == false"
              />
            </div>
          </div>
          <div class="dateDataContainer">
            <div class="dateDataContainerTitle">Country</div>
            <vSelect
              id="countrySelect"
              :options="countries"
              v-model="countryFilter"
              :disabled="isEditable == false"
            />
          </div>
        </div>
      </div>
      Recipients
      <v-radio-group :disabled="isEditable == false" v-model="recipients" row>
        <v-radio color="red" label="Send to testflight devices" value="0"></v-radio>
        <v-radio label="Send to all devices" value="1"></v-radio>
      </v-radio-group>
    </div>
    <div id="sendButtonsContainer" v-if="isEditable == true">
      <button class="formButton" id="cancelButton" v-on:click="cancelAction()">Cancel</button>
      <button class="formButton" id="sendButton" v-on:click="sendAction()">Schedule</button>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import vSelect from "vue-select";
import NotificationFormImage from "./NotificationFormImage";
import "vue-select/dist/vue-select.css";
import moment from "moment-timezone";

export default {
  name: "FormBody",
  data() {
    return {
      app_id: "8fb80b4e-299a-404a-aeab-1ba0a0db9430",
      title: "",
      message: "",
      url: "",
      edit: false,
      firebaseUrl: "",
      delivery: "0",
      recipients: "0",
      imageUrl: "",
      date: new Date(),
      hours: 0,
      minutes: 0,
      notificationData: { en: "English Message" },
      countries: ["All", "Australia", "New Zealand"],
      countryFilter: "All",
      handleAsText: (response) => response.text(),
      displayResponse: (responseText) => (this.message = responseText),
      popoverConfig: {
        placement: "top-start",
      },
    };
  },
  props: {
    startData: Object,
    isEditable: Boolean,
    view: Boolean,
  },
  computed: {
    showCalendarDate: {
      get() {
        var date = this.date.getUTCDate();
        var month = this.date.getUTCMonth() + 1;
        var year = this.date.getUTCFullYear();
        return date + "/" + month + "/" + year;
      },
    },
  },
  components: {
    DatePicker,
    vSelect,
    NotificationFormImage,
  },
  watch: {},
  methods: {
    async imageUrlInputHandler() {
      if (this.imageUrl === null || this.imageUrl === "") {
        this.showImagePreview = false;
      } else {
        this.imageUrlResult(this.imageUrl);
        this.showImagePreview = true;
        let response = await fetch(this.imageUrl);
        let data = await response.blob();
        let metadata = {
          type: "image/jpeg",
        };
        let file = new File([data], "test.jpg", metadata);
        this.imageSize = file.size;
        firebase
          .storage()
          .ref("images/" + file.name)
          .put(file)
          .then((response) => {
            response.ref.getDownloadURL().then((url) => {
              this.firebaseUrl = url;
            });
          })
          .catch((err) => console.log(err));
        // this.imageUrl = URL.createObjectURL(file);
      }
    },
    deleteImage() {
      this.imageUrl = "";
    },
    onFileChange(e) {
      const file = e.target.files[0];
      firebase
        .storage()
        .ref("images/" + file.name)
        .put(file)
        .then((response) => {
          response.ref.getDownloadURL().then((url) => {
            this.firebaseUrl = url;
          });
        })
        .catch((err) => console.log(err));
      this.imageUrl = URL.createObjectURL(file);
    },
    validateHours() {
      var isValidHour =
        /^([0-1]?[0-9]|2[0-4])?$/.test(this.hours) && this.hours <= 24;
      if (!isValidHour) {
        this.hours = this.date.getHours();
      }
    },
    validateMin() {
      var isValidMin =
        /^([0-5][0-9])(:[0-5][0-9])?$/.test(this.minutes) && this.minutes <= 59;
      if (!isValidMin) {
        this.minutes = this.date.getMinutes();
      }
      var t = moment().tz(this.timeZone).format();
      console.log(t.toDate());
    },
    formatDate(unixDate) {
      if (unixDate) {
        let date = new Date(unixDate * 1000);
        var dateString = new Date(
          date.getTime() - date.getTimezoneOffset() * 60000
        )
          .toISOString()
          .split("T")[0];
        return dateString;
      }
    },
    sendAction() {
      var actualDate = new Date();
      this.date.setMinutes(this.minutes);
      this.date.setHours(this.hours);
      var stringDate = actualDate.toString();
      if (actualDate <= this.date) {
        stringDate = this.date.toString();
      }
      if (this.url != null && this.url != "") {
        this.notificationData["url"] = this.url;
      }
      if (this.message == undefined || this.message == "") {
        this.$alert("The message is required");
        return;
      }
      var notificationJSON = {
        app_id: this.app_id,
        included_segments: ["All"],
        send_after: stringDate,
        headings: { en: this.title },
        contents: { en: this.message },
      };
      if(this.recipients != 0) {
        notificationJSON.delayed_option = "timezone";
      }
      if (this.url != null && this.url != "") {
        notificationJSON["url"] = this.url;
      }
      if (this.imageUrl != "") {
        notificationJSON["ios_attachments"] = { image: this.imageUrl };
      }
      if (this.firebaseUrl != "") {
        console.log("FIREBASE", this.firebaseUrl);
        notificationJSON["ios_attachments"] = { image: this.firebaseUrl };
      }
      console.log("notificationJSON", notificationJSON);
      if (this.countryFilter == "Australia") {
        notificationJSON.included_segments = null;
        notificationJSON.filters = [
          { field: "country", relation: "=", value: "AU" },
        ];
      }
      if (this.countryFilter == "New Zealand") {
        notificationJSON.included_segments = null;
        notificationJSON.filters = [
          { field: "country", relation: "=", value: "NZ" },
        ];
      }
      this.sendNotification(notificationJSON);
    },
    sendNotification(data) {
      if (this.startData) {
        console.log("BORRAR");
        this.deleteNotification(this.startData);
      }
      var headers = {
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Basic YmI4OGIwODUtMTM4NC00YTY1LTkyMTktNjNhZDMzZmNhZTIx",
      };
      var options = {
        host: "onesignal.com",
        port: 443,
        path: "/api/v1/notifications",
        method: "POST",
        headers: headers,
      };
      if (this.delivery == "0") {
        console.log("DELIVERY", this.delivery);
        localStorage.delivery = 0;
      } else {
        localStorage.delivery = 1;
      }
      var that = this;
      if (this.recipients == 0){
        data["included_segments"] = ["Test Devices"]
      }
      console.log(that,options,data)
      var https = require("https");
      var req = https.request(options, function (res) {
        res.on("data", function (data) {
          console.log("Response:");
          console.log(JSON.parse(data));
          that.$emit("close");
        });
      });
      req.on("error", function (e) {
        console.log("ERROR:");
        console.log(e);
        this.$emit("close");
      });
      req.write(JSON.stringify(data));
      req.end();
    },
    cancelAction() {
      localStorage.delivery = 1;
      this.$emit("close");
    },
    fillFormOnEdit() {
      console.log("START", this.startData);
      if (this.startData === undefined) {
        return;
      }
      
      if (this.startData.delivery) {
        this.delivery = "0"
      } else {
        this.delivery = "1"
      }
      this.edit = true;
      let date = new Date(this.startData.send_after * 1000);
      var dateFormatted = this.formatDate(this.startData.send_after);
      dateFormatted = dateFormatted.replace(/-/g, "/");
      console.log("AFTER", dateFormatted);
      var correctedDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000)
      this.date = correctedDate;
      this.hours = this.date.getHours();
      this.minutes = this.date.getMinutes();

      (this.title = this.startData.headings.en),
        (this.message = this.startData.contents.en),
        (this.url = this.startData.url);
      if (this.startData.ios_attachments) {
        this.imageUrl = this.startData.ios_attachments.image;
      }
      if (this.startData.filters) {
        console.log("FILTERS", this.startData.filters);
        if (this.startData.filters[0].value === "AU") {
          this.countryFilter = "Australia";
        } else {
          this.countryFilter = "New Zealand";
        }
      }
    },
    async deleteNotification(notification) {
      var headers = {
        Authorization: "Basic YmI4OGIwODUtMTM4NC00YTY1LTkyMTktNjNhZDMzZmNhZTIx",
      };
      const request = new Request(
        `https://onesignal.com/api/v1/notifications/` +
          notification.id +
          `?app_id=${this.app_id}`,
        {
          port: 443,
          method: "DELETE",
          headers: headers,
        }
      );
      const res = await fetch(request);
      const result = await res.json();
      console.log(result);
    },
    uploadImageResult(image) {
      this.imageUrl = image;
    },
    imageUrlResult(url) {
      this.imageUrl = url;
    },
  },
  beforeMount() {
    this.fillFormOnEdit();
  },
};
</script>

<style scoped>
.input {
  padding-left: 10px;
  width: 100%;
  height: 45px;
  font-size: 14px;
  border: solid 1px #cbd4dc;
  border-radius: 5px;
}

.labels {
  margin-top: 12px;
  margin-bottom: 10px;
  width: 624px;
  height: 15px;
  font-family: Roboto;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #192a3e;
}
.fromItemContainer {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: left;
  font-size: 13px;
  margin-bottom: 20px;
}
.dateDataContainer {
  width: 33%;
  display: flex;
  flex-direction: column;
  justify-content: left;
  align-items: center;
  text-align: left;
}
.dateDataContainerTitle {
  flex: 1;
  width: 100%;
  text-align: left;
}
.hourInput {
  font-size: 14px;
  height: 38px !important;
  border: solid 1px #cbd4dc;
  border-radius: 5px;
  width: 40% !important;
  text-align: center;
}
.formButton {
  font-size: 15px;
  width: 140px;
  height: 45px;
  border-radius: 4px;
  border: none;
  transition-duration: 0.4s;
}
.formButton:hover {
  background-color: #f44336;
  color: gray;
}
#formBody {
  margin: 40px 40px 40px 40px;
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: left;
  border-radius: 8px;
  font-size: 16px;
  font-family: Roboto;
}
#formBodyTitle {
  width: 180px;
  height: 19px;
  font-family: Roboto;
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #109cf1;
}
#calendarContainer {
  display: inline-block;
}
#mainDateContainer {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
}
#hourContainer {
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
}
#datePicker {
  width: 90%;
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  margin-right: 10%;
}
#countrySelect {
  width: 100%;
}
#sendButtonsContainer {
  margin-top: 25px;
  width: 100%;
  flex-direction: row;
  display: flex;
  justify-content: right;
  align-items: flex-start;
}
#sendButton {
  background-color: #109cf1;
  color: white;
}
#sendButton:disabled {
  background-color: rgb(84, 142, 179);
}
#cancelButton {
  background-color: white;
  color: #109cf1;
  border: solid 1px #cbd4dc;
  margin-right: 10px;
}
#cancelButton:disabled {
  background-color: rgba(146, 146, 146, 0.05);
}
#imageRestrictionsContainer {
  font-size: 12px;
  margin-top: 15px;
  display: flex;
  justify-content: space-evenly;
  color: #767675;
}
</style>